import { action } from 'typesafe-actions';

import { Actions } from './constants';
import { Contain } from './types';

export const closeModal = () => action(Actions.CLOSE_MODAL);
export const openModal = (props: object, contain: Contain) =>
  action(Actions.OPEN_MODAL, { props, contain });
